import type { AiBalance } from '@/api/ai';

/** ч.1173: текст «скільки кредитів Oblik+/AI доступно» для підказок і шапок сторінок.
 *  Тестовий акаунт — «без обмежень» (кредити не списуються); дані ще не
 *  завантажені — null (сторінка показує «…» або нічого).
 *  Окремий модуль (не `@/api/ai`): тести сторінок підміняють `@/api/ai` цілком. */
export function aiAvailableText(
  b: Pick<AiBalance, 'available' | 'unlimited'> | null | undefined,
): string | null {
  if (!b) return null;
  if (b.unlimited) return 'без обмежень';
  return Number(b.available).toFixed(2);
}
